<template>
  <modal-layout>
    <div class="inter-modal-header">
      <h1 class="inter-modal-title">{{ data.type }}</h1>
      <p class="inter-modal-desc">{{ data.title }}</p>
    </div>

    <div class="inter-modal-content">
      <div class="inter-modal-choice" v-for="(c, index) in choices" :class="c?.selected ? 'selected' : ''" :key="index"
        tabindex="0" @keyup.enter="handleClickChoice(index)" @click="handleClickChoice(index)">
        {{ c.choice }}
      </div>
      <div v-if="data?.redirect?.files">
        <div v-for="red in data?.redirect?.files" :key="red?.id" tabindex="0" class="redirect-quiz-style">
          <svg fill="#FFF" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 52 52"
            enable-background="new 0 0 52 52" xml:space="preserve">
            <g>
              <path d="M9.7,36.1V11.3c-2.6,0-4.7,2.1-4.7,4.6v29.4C5,47.9,7.1,50,9.7,50H33c2.6,0,4.7-2.1,4.7-4.6H19
		C13.9,45.4,9.7,45.4,9.7,36.1z" />
              <path d="M45.4,15.9h-7.8c-2.6,0-4.7-2.1-4.7-4.6V3.5C33,2.7,32.3,2,31.4,2H19c-2.6,0-4.7,2.1-4.7,4.6v29.4
		c0,2.6,2.1,4.6,4.7,4.6h23.3c2.6,0,4.7-2.1,4.7-4.6V17.5C47,16.6,46.3,15.9,45.4,15.9z" />
              <path d="M46.7,9.4l-7.2-7.1C39.3,2.1,39.1,2,38.8,2l0,0c-0.6,0-1.1,0.5-1.1,1.1v5.1c0,1.7,1.4,3.1,3.1,3.1h5.1
		c0.6,0,1.1-0.5,1.1-1.1l0,0C47,9.9,46.9,9.7,46.7,9.4z" />
            </g>
          </svg>
          <h5 class="redirect-title" @click="handleRedirectQuiz(red?.url)">
            {{ $t('interactivity.viewFile') }}
          </h5>
        </div>
      </div>
      <div v-else-if="data?.redirect?.link" class="redirect-quiz-style">
        <svg fill="#FFF" width="25px" height="25px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10,17.55,8.23,19.27a2.47,2.47,0,0,1-3.5-3.5l4.54-4.55a2.46,2.46,0,0,1,3.39-.09l.12.1a1,1,0,0,0,1.4-1.43A2.75,2.75,0,0,0,14,9.59a4.46,4.46,0,0,0-6.09.22L3.31,14.36a4.48,4.48,0,0,0,6.33,6.33L11.37,19A1,1,0,0,0,10,17.55ZM20.69,3.31a4.49,4.49,0,0,0-6.33,0L12.63,5A1,1,0,0,0,14,6.45l1.73-1.72a2.47,2.47,0,0,1,3.5,3.5l-4.54,4.55a2.46,2.46,0,0,1-3.39.09l-.12-.1a1,1,0,0,0-1.4,1.43,2.75,2.75,0,0,0,.23.21,4.47,4.47,0,0,0,6.09-.22l4.55-4.55A4.49,4.49,0,0,0,20.69,3.31Z" />
        </svg>
        <h5 class="redirect-title" @click="handleRedirectQuiz(data?.redirect?.link)">{{ $t('interactivity.linkNav') }}
        </h5>
      </div>
      <div v-else-if="data?.redirect?.type === 'video'" class="redirect-video-quiz ">
        <h5 class="video-title">
          {{ $t('interactivity.viewVideo') }}
        </h5>
        <img class="video-image" :src="data.redirect?.video_logo" width="100" height="100"
          @click="handleRedirectQuiz(data.redirect?.video_url)" alt="image" />
      </div>
    </div>
    <div class="inter-modal-footer">
      <button class="inter-modal-btn" @click="closeInteractivityModal">
        {{ $t('buttons.ignore') }}
      </button>

      <button class="inter-modal-btn" @click="handleSubmit">
        {{ $t('buttons.valid') }} &rarr;
      </button>
    </div>
  </modal-layout>
</template>

<script >
import cookies from "@/components/utils/cookies";
import { mapGetters } from "vuex";
import { defineComponent } from "vue";
import ModalLayout from "../ModalLayout.vue";
import RichMediaServices from "../../../../services/RichMediaServices/RichMediaServices";
import en from '../../../../i18n/en_US'
import fr from '../../../../i18n/fr_FR'

export default defineComponent({
  name: "inter-question",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {
    ModalLayout,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
    closeModal: {
      required: true,
      type: Function,
    },
  },
  data() {
    return {
      choices: [],
    };
  },
  computed: {
    ...mapGetters(['setVideoInfos']),
  },
  mounted() {
    this.choices =
      +this.data.nsp === 0
        ? [{ choice: "Non" }, { choice: "Oui" }]
        : [{ choice: "Non" }, { choice: "Oui" }, { choice: "NSP" }];
    this.choices.forEach((choice) => {
      choice.selected = false;
    });
  },
  methods: {
    handleRedirectQuiz(url) {

      if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, "_blank");
    },
    handleClickChoice(i) {
      for (let j = 0; j < this.choices.length; j++) {
        if (j === i) {
          this.choices[j].selected = !this.choices[j].selected;
        } else {
          this.choices[j].selected = false;
        }
      }
    },
    handleSubmit() {
      let indexToSubmit =
        this.choices.findIndex((element) => element.selected) + "";
      if (indexToSubmit) {
        let objToSend = {
          client: this.setVideoInfos?.client,
          votes: [
            {
              id_inter: this.data.id,
              id_user: cookies.cookiesUserId(),
              responses: indexToSubmit,
              type: this.data.type,
            },
          ],
        };
        RichMediaServices.postRichMediaResponse(objToSend)
          .then(() => {
            this.closeModal();
          })
      }
    },
    closeInteractivityModal() {
      this.closeModal();
    },
  },
});
</script>

<style scoped>
.redirect-quiz-style {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 8px;
}

.redirect-title {
  font-family: "Open Sans", sans-serif;
  font-size: 0.9rem;
}

.redirect-title:hover {
  text-decoration: underline;
  cursor: pointer;
}

.redirect-video-quiz {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.video-title {
  font-size: 16px;
}

.video-image {
  width: 50%;
  height: 50%;
  cursor: pointer;
}
</style>
